<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showOffer") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #E1423D">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper" v-if="!loading">
      <form>
        <div class="row">
          <!-- Start:: Product Image Display -->
          <div class="col-12 text-center my-3" v-if="offerData.product?.main_image">
            <div class="preview-container">
              <img
                :src="offerData.product.main_image"
                alt="Product Image"
                style="max-width: 300px; max-height: 300px; border: 1px solid #ccc; border-radius: 8px;"
              />
            </div>
          </div>
          <!-- End:: Product Image Display -->

          <!-- Start:: Product Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.productName')"
            :value="offerData.product?.name || ''"
            disabled
          />
          <!-- End:: Product Name -->

          <!-- Start:: Category Display -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.category')"
            :value="offerData.product?.category?.name || ''"
            disabled
          />
          <!-- End:: Category Display -->

          <!-- Start:: Discount Percentage -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.discountPercentage')"
            :value="offerData.discount_percentage ? offerData.discount_percentage + '%' : ''"
            disabled
          /> -->
          <!-- End:: Discount Percentage -->

          <!-- Start:: Status -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.offerStatus')"
            :value="offerData.status_label || offerData.status || ''"
            disabled
          />
          <!-- End:: Status -->

          <!-- Start:: Start Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.offerStartDate')"
            :value="offerData.start_date || ''"
            disabled
          />
          <!-- End:: Start Date -->

          <!-- Start:: End Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.offerEndDate')"
            :value="offerData.end_date || ''"
            disabled
          />
          <!-- End:: End Date -->

          <!-- Start:: Created At -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            :value="offerData.created_at || ''"
            disabled
          />
          <!-- End:: Created At -->

          <!-- Start:: Is Active -->
          <div class="col-6 my-5">
            <v-chip
              :color="offerData.is_active ? 'success' : 'error'"
              text-color="white"
              small
            >
              {{
                offerData.is_active
                  ? $t("STATUS.active")
                  : $t("STATUS.notActive")
              }}
            </v-chip>
          </div>
          <!-- End:: Is Active -->

          <!-- Start:: Product Prices List -->
          <!-- <div class="col-12" v-if="offerData.prices && offerData.prices.length > 0">
            <div class="prices-section-header mb-4">
              <h5 class="mb-0" style="color: #E1423D; font-weight: 600;">
                <i class="fas fa-dollar-sign mr-2"></i>
                {{ $t('PLACEHOLDERS.productPrices') }}
              </h5>
            </div>
            
            <div class="prices-list">
              <div
                v-for="(price, index) in offerData.prices"
                :key="index"
                class="price-card mb-4"
              >
                <div class="price-card-header">
                  <div class="price-card-title">
                    <i class="fas fa-tag mx-2" style="color: #E1423D;"></i>
                    <span style="font-weight: 600;">
                      {{ $t('PLACEHOLDERS.quantity') }}: {{ price.quantity }} {{ price.quantity_unit }}
                    </span>
                  </div>
                </div>
                
                <div class="price-card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="price-field-label">
                        {{ $t('PLACEHOLDERS.originalPrice') }}:
                      </label>
                      <p style="font-size: 1.1rem; font-weight: 600; color: #333;">
                        {{ price.price }} {{ $t('PLACEHOLDERS.riyal') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- End:: Product Prices List -->

          <!-- Start:: Prices After Discount List -->
          <div class="col-12" v-if="offerData.prices_after_discount && offerData.prices_after_discount.length > 0">
            <div class="prices-section-header mb-4">
              <h5 class="mb-0" style="color: #E1423D; font-weight: 600;">
                <i class="fas fa-percent mr-2"></i>
                {{ $t('PLACEHOLDERS.productPrice') }}
              </h5>
            </div>
            
            <div class="prices-list">
              <div
                v-for="(price, index) in offerData.prices_after_discount"
                :key="index"
                class="price-card mb-4"
              >
                <div class="price-card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="price-field-label">
                        {{ $t('PLACEHOLDERS.originalPrice') }}:
                      </label>
                      <p style="font-size: 1.1rem; font-weight: 600; color: #333;">
                        {{ price.original_price }} {{ $t('PLACEHOLDERS.riyal') }}
                      </p>
                    </div>
                    
                    <div class="col-md-6">
                      <label class="price-field-label">
                        {{ $t('PLACEHOLDERS.priceAfterDiscount') }}:
                      </label>
                      <p style="font-size: 1.1rem; font-weight: 600; color: #E1423D;">
                        {{ price.discounted_price }} {{ $t('PLACEHOLDERS.riyal') }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End:: Prices After Discount List -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->

    <!-- Start:: Loading State -->
    <div v-if="loading" class="text-center my-5">
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>
    <!-- End:: Loading State -->
  </div>
</template>

<script>
export default {
  name: "ShowOffer",

  data() {
    return {
      loading: false,
      offerData: {},
      offerId: null,
    };
  },

  methods: {
    // Start:: Get Offer Data
    async getOfferData() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `offers/${this.offerId}`,
        });
        this.offerData = res.data.data;
      } catch (error) {
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      } finally {
        this.loading = false;
      }
    },
    // End:: Get Offer Data
  },

  created() {
    // Start:: Fire Methods
    this.offerId = this.$route.params.id;
    this.getOfferData();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.prices-section-header {
  padding-bottom: 1rem;
  border-bottom: 2px solid #E1423D;
}

.price-card {
  border: 1px solid #E1423D;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  overflow: hidden;
}

.price-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #E1423D;
}

.price-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #E1423D;
}

.price-card-title {
  display: flex;
  align-items: center;
  font-size: 1rem;
}

.price-card-body {
  padding: 1.25rem;
}

.price-field-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #555;
  margin-bottom: 0.5rem;
}
</style>

